// client/src/components/profissionais/ProfissionalCard.js
import React, { useState } from 'react';
import { MoreVertical, MapPin, Settings, CheckCircle, XCircle, Phone } from 'lucide-react';

const ProfissionalCard = ({ profissional, onOpenActions }) => {
    const user = profissional.user || profissional;
    
    // Status e Contadores
    // A API escalável do backend injeta as contagens na raiz do objeto.
    // Mas as garante aqui buscando em múltiplos lugares para não zerar.
    const unidadesCount = profissional.unidadesCount || profissional.estatisticas?.totalUnidades || 0;
    const servicosCount = profissional.servicosCount || profissional.estatisticas?.totalServicos || 0;
    
    // Status prioriza a informação consolidada da página
    const status = profissional.profissionalInfo?.status || profissional.status || 'ativo';
    const isAtivo = status === 'ativo';

    const [imgError, setImgError] = useState(false);

    const getPhotoUrl = () => {
        if (imgError) {
             return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
        }
        const photo = user.photoUrl || user.photo;
        if (photo && typeof photo === 'string' && photo.length > 5) {
            return photo;
        }
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=random`;
    };

    return (
        <div className={`bg-white border rounded-lg p-5 hover:shadow-md transition-all flex flex-col h-full ${!isAtivo ? 'opacity-70 bg-gray-50' : ''}`}>
            <div className="flex items-start gap-4 mb-4">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 border border-gray-200">
                    <img
                        src={getPhotoUrl()}
                        alt={user.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            e.target.onerror = null;
                            setImgError(true);
                        }}
                    />
                </div>
                
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                        <h3 className="font-semibold text-gray-900 truncate pr-2">
                            {user.name}
                        </h3>
                    </div>
                    
                    <div className="flex items-center text-xs text-gray-500 font-mono mb-2">
                        <Phone size={12} className="mr-1 text-gray-400" />
                        {user.telefone || 'Sem telefone'}
                    </div>

                    <div className="flex items-center">
                        {isAtivo ? (
                            <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-green-100 text-green-700 border border-green-200">
                                <CheckCircle size={10} className="mr-1" /> Ativo
                            </span>
                        ) : (
                            <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-red-50 text-red-600 border border-red-200">
                                <XCircle size={10} className="mr-1" /> Inativo
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mt-auto pb-4">
                <div className="bg-gray-50 rounded p-2 text-center border border-gray-100">
                    <span className="block text-xs text-gray-500 mb-1 flex items-center justify-center">
                        <Settings size={12} className="mr-1 text-gray-400"/> Serviços
                    </span>
                    <span className="font-semibold text-gray-800">
                        {servicosCount}
                    </span>
                </div>
                <div className="bg-gray-50 rounded p-2 text-center border border-gray-100">
                    <span className="block text-xs text-gray-500 mb-1 flex items-center justify-center">
                        <MapPin size={12} className="mr-1 text-gray-400"/> Unidades
                    </span>
                    <span className="font-semibold text-gray-800">
                        {unidadesCount}
                    </span>
                </div>
            </div>

            <div className="mt-auto pt-3 border-t border-gray-100 flex justify-end items-center">
                <button
                    onClick={() => onOpenActions(profissional)}
                    className="action-icon-button text-gray-600"
                    title="Ações"
                    type="button"
                >
                    <MoreVertical size={18} />
                </button>
            </div>
        </div>
    );
};

export default ProfissionalCard;